import { RemoteSelfRegistrationService } from '@prodcard/core-web-app'
import { httpClient } from './remote'

export const selfRegistrationService = new RemoteSelfRegistrationService(httpClient)
